module.exports = __webpack_public_path__ + "static/media/not-found.4cd54511.svg";